var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
var DEFAULT_VALUE = {
    isShiftDown: false,
    keys: [],
};
var KeyDownContext = createContext(DEFAULT_VALUE);
export var KeyDownProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), keys = _b[0], setKeys = _b[1];
    // Shift requires special handling because it is a shortcut key
    var isShiftDown = keys.includes('Shift') && !keys.includes('Meta');
    useEffect(function () {
        if (typeof window === 'undefined') {
            return;
        }
        var handleKeyDown = function (event) {
            setKeys(function (keys) { return __spreadArray(__spreadArray([], keys, true), [event.key], false); });
        };
        window.addEventListener('keydown', handleKeyDown);
        var handleKeyUp = function (event) {
            setKeys(function (keys) { return __spreadArray([], keys.filter(function (key) { return key !== event.key; }), true); });
        };
        window.addEventListener('keyup', handleKeyUp);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    var value = useMemo(function () { return ({ keys: keys, isShiftDown: isShiftDown }); }, [keys, isShiftDown]);
    return _jsx(KeyDownContext.Provider, __assign({ value: value }, { children: children }));
};
export var useKeyDown = function () {
    var context = useContext(KeyDownContext);
    if (context == null) {
        return DEFAULT_VALUE;
    }
    return context;
};
export default KeyDownContext;
